import React, { Component } from 'react'
import ScrollToTop from '../../../components/ScrollToTop';
import SubMenuSider from '../../../components/SubMenuSider';
import { Table, Collapse } from 'antd'
import { Odata_Url, Odata_Filestream_Url, Constants } from '../../../Constants/Constants'
import './Summary.css'

const Panel = Collapse.Panel;

export default class summary extends Component {
    constructor() {
        super();

        this.state = {
            ObtranID: '',
            dataObservation: [],
            dataCompany: "",
            dataShift: [],
            dataArea: [],
            dataSumArea: [],
            dataJobType: [],
            datadetail: [],
            datarootcause: [],
            dataAttachment: [],
            dataobservertype: [],
            dataUser: [],
            data_image: [],
            type_observation: "",
            previewVisible: false,
            previewImage: '',
            fileList: [],
            visible: false,
            near_miss: false,
            parent: '/myobservation'

        };

        this.set_image = this.set_image.bind(this);

    }

    componentWillMount() {
        const axios = require('axios');
        var observation_detail = this.props.location.state.Obtran
        // console.log(observation_detail)
        var CompanyID = this.props.location.state.Obtran.CompanyID

        if (this.props.location.state.parent !== undefined)
            this.setState({ parent: this.props.location.state.parent })

        var Token
        axios.get(Constants.BASE_URL + 'auth/token')
            .then((response) => {
                Token = response.data
                // console.log(Token)
                axios.get(
                    Odata_Url + 'OCompanyMD?$filter=IsActived eq true and PKCompanyID eq ' + CompanyID,
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        var data;

                        response.data.value.forEach(function (element) {
                            data = element
                        });
                        //console.log(data);
                        this.setState({
                            dataCompany: data,
                        })
                    },
                        (error) => {
                            console.log(error);
                        });

                var UserID = this.props.location.state.Obtran.UserID
                axios.get(
                    Odata_Url + 'OUserMD?$filter=IsActived eq true and PKUserID eq ' + UserID,
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        var data;

                        response.data.value.forEach(function (element) {
                            data = element
                        });
                        //console.log(data);
                        this.setState({
                            dataUser: data,
                        })
                    },
                        (error) => {
                            console.log(error);
                        });

                var AreaID = this.props.location.state.Obtran.AreaID
                axios.get(
                    Odata_Url + 'OAreaMD?$filter=IsActived eq true',
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        var data;
                        var Area = [];

                        response.data.value.forEach(function (element) {
                            if (element.PKAreaID === AreaID) {
                                data = element
                            }
                            Area.push(element)
                        });
                        //console.log(data);  
                        this.setState({
                            dataArea: data,
                            dataSumArea: Area
                        })
                    },
                        (error) => {
                            console.log(error);
                        });

                // var JobTypeID = this.props.location.state.Obtran.JobType
                var ObtranID = observation_detail.PkObTranID
                this.setState({ ObtranID: ObtranID })
                axios.get(
                    Odata_Url + 'OObservation_Job_Detail?$filter=IsActived eq true and ObTranID eq ' + ObtranID,
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        var data = []
                        response.data.value.forEach(function (element) {
                            data.push(element.Job_detail)
                        });
                        // console.log(data);
                        this.setState({
                            dataJobType: data,
                        })
                    },
                        (error) => {
                            console.log(error);
                        });

                axios.get(
                    Odata_Url + 'OObservation_ObserverType?$filter=IsActived eq true and ObTranID eq ' + ObtranID,
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        var data = []

                        response.data.value.forEach(function (element) {
                            data.push(element.ObserverType_Name)
                        });
                        // console.log(data);
                        this.setState({ dataobservertype: data })
                    },
                        (error) => {
                            console.log(error);
                        });

                var count_rootcause = 0;
                var count_nearmiss = 0;
                axios.get(
                    Odata_Url + 'OObservation_Category_Detail?$filter=IsActived eq true and ObTranID eq ' + ObtranID,
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        var data_rootcause = []
                        var data_detail = []
                        response.data.value.forEach(function (element) {
                            if (element.Root_cause !== null) {
                                data_detail.push(element)
                                count_rootcause++
                            }
                            if (element.Near_miss) {
                                count_nearmiss++
                            }
                        });
                        // console.log(data_detail);
                        this.setState({
                            datarootcause: data_rootcause,
                            datadetail: data_detail
                        })
                        // count_rootcause variable it mean observation is safe or unsafe , if eq = 0 is safe else is unsafe
                        if (count_rootcause !== 0) {
                            this.setState({ type_observation: "Unsafe" })
                        } else {
                            this.setState({ type_observation: "Safe" })
                        }
                        if (count_nearmiss !== 0) {
                            this.setState({
                                near_miss: true
                            })
                        }
                    },
                        (error) => {
                            console.log(error);
                        });
                // Pull image from database

                // console.log(ObtranID)
                axios.get(
                    Odata_Url + 'OAttachment?$filter=IsActived eq true and ObtranID eq ' + ObtranID,
                    {
                        headers: {
                            "Authorization": "Bearer " + Token,
                        }
                    }
                )
                    .then((response) => {
                        var Guid_image = []
                        response.data.value.forEach(function (element) {
                            Guid_image.push(element.Guid)
                        });
                        var image = []
                        Guid_image.map((l, i) => {
                            axios.get(
                                Odata_Filestream_Url + "OFilesTable?$filter=Active eq true and Guid eq (guid'" + l + "')",
                            )
                                .then((response) => {
                                    response.data.value.forEach(function (element2) {
                                        // console.log(element2)
                                        image.push(element2);
                                    });

                                    this.set_image(image)
                                },
                                    (error) => {
                                        console.log(error);
                                    })
                            return true
                        })

                        this.set_image(image)
                        // console.log(data_image);

                    },
                        (error) => {
                            console.log(error);
                        });

            },
                (error) => {
                    if (401 === error.response.status) {
                        window.location.href = "auth";
                    }
                });
    }

    set_image(image) {
        this.setState({
            data_image: image
        })
    }
    handleCancel = () => this.setState({ previewVisible: false })

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    }
    handleChange = ({ fileList }) => this.setState({ fileList })

    handleOk = (e) => {
        this.setState({
            visible: false,
        });
        this.props.history.push('/news');
    }
    render() {
        const { dataSumArea, dataJobType, dataobservertype, near_miss, type_observation, data_image, datadetail, dataUser } = this.state;
        // console.log(dataUser)
        var data_category_safe = []
        var data_category_unsafe = []
        var data_rootcause = []
        var cate = JSON.parse(window.localStorage.getItem('Category'))
        var count_data_category_safe = 0
        var count_data_category_unsafe = 0
        var count_data_rootcause = 0
        datadetail.map((l, i) => {
            if (l.Detail !== null) {
                if (l.Type_Of_Category === "Safe") {
                    data_category_safe[count_data_category_safe] = { category_name: cate[i].Category_Name, detail: l.Detail }
                    count_data_category_safe++;
                }
                if (l.Type_Of_Category === "Unsafe") {
                    data_category_unsafe[count_data_category_unsafe] = { category_name: cate[i].Category_Name, detail: l.Detail }
                    count_data_category_unsafe++;

                    data_rootcause[count_data_rootcause] = { category_name: cate[i].Category_Name, root_cause: l.Root_cause }
                    count_data_rootcause++;
                }
            }
            return null
        })
        var observation_detail = this.props.location.state.Obtran
        var Unsafe_detail_corrective_action = observation_detail.Unsafe_detail_corrective_action
        var Unsafe_detail_next_action = observation_detail.Unsafe_detail_next_action
        var Safe_detail = observation_detail.Safe_detail
        if (Unsafe_detail_corrective_action === "") {
            Unsafe_detail_corrective_action = "-"
        }
        if (Unsafe_detail_next_action === "") {
            Unsafe_detail_next_action = "-"
        }
        if (Safe_detail === "") {
            Safe_detail = "-"
        }
        var AreaID = this.props.location.state.Obtran.AreaID
        var Shift = this.props.location.state.Obtran.Shift
        var AreaParent
        var AreaOrder
        var AreaBuilding



        this.state.dataSumArea.map((l, i) => {
            if (l.PKAreaID === AreaID) {
                AreaParent = l.Parentid
                AreaOrder = l.Ordering
                AreaBuilding = l.Name
            }
            return null
        })

        var Area = [AreaBuilding]
        //console.log(observation_detail)
        for (let i = 1; i < AreaOrder; i++) {
            for (let j = 0; j < dataSumArea.length; j++) {
                if (dataSumArea[j].PKAreaID === AreaParent) {
                    Area.splice(0, 0, dataSumArea[j].Name)
                    AreaParent = dataSumArea[j].Parentid
                    break;
                }
            }
        }

        if (this.state.dataAttachment === undefined) {
            alert("kiki")
        }
        // console.log(this.state.dataAttachment.length)
        const columns_rootcause = [
            {
                key: 1,
                title: "Category",
                dataIndex: "category_name",
                width: "50%"
            },
            {
                key: 2,
                title: "Root cause",
                dataIndex: "root_cause",
                width: "50%"
            }
        ];
        const columns_safe_detail_category = [
            {
                key: 1,
                title: "Category",
                dataIndex: "category_name",
                width: "50%"
            },
            {
                key: 2,
                title: "Safe detail",
                dataIndex: "detail",
                width: "50%"
            }
        ];

        const columns_unsafe_detail_category = [
            {
                key: 1,
                title: "Category",
                dataIndex: "category_name",
                width: "50%"
            },
            {
                key: 2,
                title: "Unsafe detail",
                dataIndex: "detail",
                width: "50%"
            }
        ];
        return (
            <div>
                <ScrollToTop />
                <SubMenuSider title="Summary" path={this.state.parent} back={{ ObtranID: this.state.ObtranID }}>
                    <div className="body-summary" style={{ width: "100%" }}>
                        <div>
                            {
                                (type_observation === "Safe") && (
                                    <div style={{ width: "100%", paddingLeft: "12px", paddingTop: "10px", paddingBottom: "5px", borderBottom: "1px solid #d9d9d9" }}>
                                        <div style={{ width: "100%", display: "inline-block", color: "black", display: "inline-block" }} key="Job">
                                            The job observed is
                                            <div style={{ marginLeft: "10px", width: "70px", backgroundColor: "green", color: "white", borderRadius: "5px", textAlign: "center", display: "inline-block" }}>
                                                Safe
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {
                                (type_observation === "Unsafe") && (
                                    <div style={{ width: "100%", paddingLeft: "12px", paddingTop: "10px", paddingBottom: "5px", borderBottom: "1px solid #d9d9d9" }}>
                                        <div style={{ width: "100%", display: "inline-block", color: "black", display: "inline-block" }} key="Job">
                                            The job observed is
                                            <div style={{ marginLeft: "10px", width: "70px", backgroundColor: "red", color: "white", borderRadius: "5px", textAlign: "center", display: "inline-block" }}>
                                                Unsafe
                                            </div>
                                        </div>
                                    </div>
                                )
                            }


                            <Collapse bordered={false} defaultActiveKey={["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13"]}>

                                {
                                    (near_miss) && (
                                        <Panel header="Near miss" key="1" showArrow={false} style={{ paddingTop: "0" }}>
                                            This report is also near miss case
                                            </Panel>
                                    )
                                }
                                {
                                    (data_image.length !== 0) && (
                                        <Panel header="Image" key="2" showArrow={false}>
                                            {
                                                data_image.map((l, i) => {
                                                    // console.log(l)
                                                    if ((i % 2) === 0) {
                                                        return (
                                                            <img className="image-summary" src={`data:image/jpeg;base64,${l.Data}`} style={{ objectFit: "cover ", borderRadius: "5px", marginRight: "4%" }} />
                                                        )
                                                    } else {
                                                        return (
                                                            <img className="image-summary" src={`data:image/jpeg;base64,${l.Data}`} style={{ objectFit: "cover ", borderRadius: "5px" }} />
                                                        )
                                                    }

                                                })
                                            }
                                        </Panel>
                                    )
                                }
                                <Panel header="Observation Date and Time " key="3" showArrow={false}>
                                    {observation_detail.Observation_Date.slice(8, 10)}-
                                    {observation_detail.Observation_Date.slice(5, 7)}-
                                    {observation_detail.Observation_Date.slice(0, 4)}
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{observation_detail.Observation_Time}
                                </Panel>
                                <Panel header="Observer" key="4" showArrow={false}>
                                    <p>
                                        {dataUser.UserFullName_ENG}
                                    </p>
                                </Panel>
                                <Panel header="Shift" key="5" showArrow={false}>
                                    <p>
                                        {Shift}
                                    </p>
                                </Panel>
                                <Panel header="Observed Location / Site" key="6" showArrow={false}>
                                    <p>
                                        {
                                            Area.map((l, i) => {
                                                if (i !== (Area.length - 1)) {
                                                    return (
                                                        l + ' / '
                                                    )
                                                } else {
                                                    return (
                                                        l
                                                    )
                                                }
                                            })
                                        }
                                    </p>
                                </Panel>
                                <Panel header="Type of observation people" key="7" showArrow={false}>
                                    <ul>
                                        {dataobservertype.map((l, i) => {
                                            return (
                                                <li key={i}>
                                                    {l}
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </Panel>
                                <Panel header="Job type" key="8" showArrow={false}>
                                    <ul>
                                        {
                                            dataJobType.map((l, i) => {
                                                return (
                                                    <li key={i}>{l}</li>
                                                )
                                            })
                                        }
                                    </ul>
                                </Panel>
                                {
                                    (data_category_safe.length > 0) && (
                                        <Panel header="Safe Detail" key="9" showArrow={false}>
                                            <Table rowKey={row => row.category_name} columns={columns_safe_detail_category} dataSource={data_category_safe} size="small" style={{ padding: "0" }} pagination={false} />
                                        </Panel>
                                    )
                                }
                                {
                                    (data_category_unsafe.length > 0) && (
                                        <Panel header="Unsafe Detail" key="10" showArrow={false}>
                                            <Table rowKey={row => row.category_name} columns={columns_unsafe_detail_category} dataSource={data_category_unsafe} size="small" style={{ padding: "0" }} pagination={false} />
                                        </Panel>
                                    )
                                }
                                {
                                    (type_observation === "Unsafe") && (
                                        <Panel header="Root cause" key="11" showArrow={false}>
                                            <Table rowKey={row => row.category_name} columns={columns_rootcause} dataSource={data_rootcause} size="small" style={{ padding: "0" }} pagination={false} />
                                        </Panel>
                                    )
                                }
                                {
                                    (type_observation === "Unsafe") && (
                                        <Panel header="Immediate corrective action" key="12" showArrow={false}>
                                            <p>
                                                {Unsafe_detail_corrective_action}
                                            </p>
                                        </Panel>

                                    )
                                }
                                {
                                    (type_observation === "Unsafe") && (
                                        <Panel header="Action" key="13" showArrow={false}>
                                            <p>
                                                {Unsafe_detail_next_action}
                                            </p>
                                        </Panel>
                                    )
                                }


                            </Collapse>
                        </div>
                    </div>
                </SubMenuSider>
            </div>
        );
    }
}